import Header from './components/Header';
import Hero from './components/Hero';
import Problems from './components/Problems';
import Services from './components/Services';
import Equipment from './components/Equipment';
import ServiceArea from './components/ServiceArea';
import Contact from './components/Contact';
import Reasons from './components/Reasons';
import Profile from './components/Profile';
import FAQ from './components/FAQ';
import Location from './components/Location';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <Hero />
      <Problems />
      <Services />
      <Equipment />
      <ServiceArea />
      <Contact />
      <Reasons />
      <Profile />
      <FAQ />
      <Location />
      
      {/* フッター直前の案内文 */}
      <section className="py-10 px-4 bg-cyan-50/50">
        <div className="max-w-xl mx-auto text-center">
          <p className="text-base md:text-lg font-bold text-gray-800 mb-3">
            はじめての方も、お気軽にご相談ください
          </p>
          <p className="text-sm text-gray-600 font-normal leading-relaxed">
            「こんなこと聞いていいのかな？」と思うことでも大丈夫です。料金のこと、作業内容のこと、何でもお気軽にお問い合わせください。無理なおすすめは一切いたしません。
          </p>
          <div className="mt-5">
            <a
              href="https://lin.ee/ltlhjZa"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-[#06C755] hover:bg-[#05b34c] text-white font-bold py-3 px-6 rounded-full transition-all duration-300 shadow-md whitespace-nowrap cursor-pointer"
            >
              <i className="ri-line-fill text-lg"></i>
              <span>LINEで気軽に相談する</span>
            </a>
          </div>
        </div>
      </section>

      <Footer />
      
      {/* スマホ用 LINE追従ボタン */}
      <a
        href="https://lin.ee/ltlhjZa"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-4 left-1/2 -translate-x-1/2 z-50 flex items-center gap-2 bg-[#06C755] text-white px-5 py-2.5 rounded-full shadow-lg hover:bg-[#05b34c] transition-all md:hidden"
      >
        <span className="w-5 h-5 flex items-center justify-center">
          <i className="ri-line-fill text-lg"></i>
        </span>
        <span className="text-sm font-medium whitespace-nowrap">LINEで質問する</span>
      </a>
    </div>
  );
}
